export const EMAIL_TEMPLATES_TABS = {
  COMPOSE: "compose",
  HISTORY: "history",
} as const;

export const EMAIL_TYPES = {
  //BE
  FOLLOW_UP: "follow_up", //sent by AI follow up copy
  USER_SENT: "user_sent",
  RECEIVED_FROM_PROSPECT: "received_from_prospect",
  COLD_OUTREACH: "cold_outreach", //sent by AI agent
  COLD_OUTREACH_FOLLOW_UP: "cold_outreach_follow_up", //sent by AI follow up copy

  //FE only
  FOLLOW_UP_SCHEDULED: "follow_up_scheduled",
} as const;

export const EMAIL_SENDER_LABEL = {
  [EMAIL_TYPES.FOLLOW_UP]: "Sent by AI followup",
  [EMAIL_TYPES.USER_SENT]: "Sent by you",
  [EMAIL_TYPES.RECEIVED_FROM_PROSPECT]: "Received from prospect",
  [EMAIL_TYPES.COLD_OUTREACH]: "Sent by AI agent",
  [EMAIL_TYPES.COLD_OUTREACH_FOLLOW_UP]: "Sent by AI followup",
  [EMAIL_TYPES.FOLLOW_UP_SCHEDULED]: "Scheduled by AI followup",
};

export const EMAIL_DRAFT_FIELDS = {
  SUBJECT: "subject",
  BODY: "body",
  ATTACHMENTS: "attachments",
  TO: "to",
  CC: "cc",
  BCC: "bcc",
} as const;

export const DEFAULT_PROMPT_NAME = "Untitled prompt";
